import TeamService from 'services/team/TeamService';

export default {
	'services.teamService': {
		class: TeamService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
